import { cmsApiService as s } from "@waitroom/common-api";
import { CACHE_KEY_CMS_PAGE as g, CACHE_KEY_CMS_PAGES as i } from "../cache/keys.es.js";
import { inactiveOptions as a, emptyCacheKey as p } from "../options.es.js";
const u = (e) => [g, e], l = ({
  slug: e,
  isPreview: n
}) => ({
  queryKey: e ? u(e) : p,
  queryFn: () => s.getPage(e || ""),
  ...a[n ? 0 : "5m"],
  enabled: !!e
}), C = (e) => [i, e], E = ({
  types: e,
  isPreview: n
}) => ({
  queryKey: C(e),
  queryFn: async () => {
    var y;
    const o = await s.getPages(e);
    if (!((y = o == null ? void 0 : o.data) != null && y.result)) throw o;
    const m = o.data.result.reduce(
      (r, t) => t.type ? t.type === "general" ? (t.category && (r.general[t.category] = [...r[t.type][t.category] || [], t]), r) : (r[t.type] = [...r[t.type] || [], t], r) : r,
      {
        general: {
          // here because of the order
          features: [],
          solutions: [],
          compare: [],
          resources: [],
          product: [],
          none: []
        }
      }
    );
    return {
      ...o,
      grouped: m
    };
  },
  ...a[n ? 0 : "15m"],
  gcTime: n ? 0 : 864e5
  // 1 day
});
export {
  l as cmsPageQuery,
  E as cmsPagesQuery,
  u as getCmsPageQueryKey,
  C as getCmsPagesQueryKey
};
